import React from 'react';
import { Input } from 'antd';
import { FormItemHeight } from '../constants';
var InputFiled = function (props) {
    var _a = props.label, label = _a === void 0 ? '标签' : _a, value = props.value, onChange = props.onChange;
    return (React.createElement("div", { className: "group" },
        React.createElement("label", null, label),
        React.createElement(Input, { value: value, style: {
                height: FormItemHeight,
            }, onChange: function (e) {
                onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
            } })));
};
export default InputFiled;
